import { ContainerModule } from "inversify";
import TypeformCsatGatewayAdapter from "../services/adapters/TypeformCsatGatewayAdapter";
import {
  ITypeformCsatGateway,
  TypeformCsatGatewayDi
} from "../services/gateways/TypeformCsatGateway";

const typeformCsatContainer = new ContainerModule((bind) => {
  bind<ITypeformCsatGateway>(TypeformCsatGatewayDi).to(
    TypeformCsatGatewayAdapter
  );
});

export { typeformCsatContainer };
